import React from 'react';
import { DisplayFixture } from '../../domain/entities';
import './FormDisplay.css';

interface FormDisplayProps {
    results: ('W' | 'D' | 'L')[];
    fixtures?: DisplayFixture[];
    onFixtureClick?: (fixture: DisplayFixture) => void;
}

export const FormDisplay: React.FC<FormDisplayProps> = ({ results, fixtures, onFixtureClick }) => (
    <div className="team-form-display">
        {results.map((r, i) => {
            const className = `form-blob ${r === 'W' ? 'form-win' : r === 'D' ? 'form-draw' : 'form-loss'}`;
            const fixture = fixtures?.[i];
            const title = fixture ? `${fixture.home} ${fixture.result?.homeScore} - ${fixture.result?.awayScore} ${fixture.away}` : (r === 'W' ? 'Win' : r === 'D' ? 'Draw' : 'Loss');
            
            if (fixture && onFixtureClick) {
                return (
                    <button 
                        key={i} 
                        className={className} 
                        title={title} 
                        onClick={() => onFixtureClick(fixture)} 
                    />
                );
            }

            return <div key={i} className={className} title={title} />;
        })}
    </div>
);
